import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";

class GroupCollectinoPresenter extends BaseFormPresenter {
  componentDidMount() {
    this.init();
    this.getObject();
  }

  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async save() {
    const collection = this.view.getCollectionName();
    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }
    try {
      const scheduleTemplate = await findObjectUseCase().execute(
        "schedule_template",
        { where: { "groupEmployee.id": this.object.id } },
      );
      // check if this schedule already pointed
      if (this.object.id && scheduleTemplate.length > 0) {
        const { deletedObjects, addedObjects } = this.view.state;

        if (deletedObjects.length > 0) {
          //delete
          deletedObjects.forEach(async (objID) => {
            const employee = {
              id: objID,
              selectedSchedule: null,
            };
            await upsertUseCase().execute("employees", employee);
          });
        }

        if (addedObjects.length > 0) {
          //add
          addedObjects.forEach(async (objID) => {
            const employee = {
              id: objID,
              selectedSchedule: { id: scheduleTemplate[0].id },
            };
            await upsertUseCase().execute("employees", employee);
          });
        }
      }

      await this.upsertUseCase.execute(collection, this.change);
      this.showSuccess("Success");
      this.change = {};
    } catch (error) {
      throw error; // rethrow the error to be caught by the caller
    }
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    // console.log("collection", collection);
    // console.log("first");
    const id = this.object.id || this.view.getObjectId();
    if (id) {
      // const params = { include: ["all"] };
      const params = {
        include: ["groupEmployee"],
      };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        // console.log("objecrt", this.object);
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }
}

export default GroupCollectinoPresenter;
